const FAQSection: React.FC = () => {
	return <> </>;
};

export default FAQSection;
